<template>
  <gl-table-two-columns :rows="prepareData()" title="Summary" />
</template>

<script>
import GlTableTwoColumns from '../../shared/GlTableTwoColumns/index'
import { formatDistance } from 'date-fns'
import { typeToTitle } from '@/tools'

export default {
  name: 'TransactionSummary',
  components: { GlTableTwoColumns },
  props: {
    tx: {
      type: Object,
      required: true,
    },
  },
  methods: {
    prepareData() {
      return [
        {
          title: 'Size',
          value: this.tx.size,
        },
        {
          title: 'Received',
          value: formatDistance(new Date(this.tx.time), new Date(), { addSuffix: true }),
        },
        {
          title: 'Date and Time',
          value: new Date(this.tx.time).toUTCString(),
        },
        {
          title: 'Included in Block',
          value: this.tx.blockNumber,
          to: { name: 'Block', params: { id: this.tx.blockNumber } },
        },
        {
          title: 'Confirmations',
          value: `${this.tx.confirmations} Confirmations`,
        },
        {
          title: 'Type',
          value: typeToTitle(this.tx.type),
        },
      ]
    },
  },
}
</script>
